import { Link } from "react-router-dom";
import { FullPageMessage } from "../components/FullPageMessage";
import { useDocumentTitle } from "../lib/useDocumentTitle";

export function NotFoundPage() {
  useDocumentTitle("Page not found · TryLook");
  return (
    <FullPageMessage title="Page not found">
      <p className="muted">The page you're looking for doesn't exist or has moved.</p>
      <Link to="/" className="btn btn-primary">
        Go to the homepage
      </Link>
    </FullPageMessage>
  );
}
